import './style.css';
import HomeSectionAccordion from '../HomeSectionAccordion/HomeSectionAccordion';

const trustItems = [
  {
    title: 'Работаем с фактической геометрией',
    text: 'Документация и модели создаются по данным лазерного сканирования без упрощений.',
  },
  {
    title: 'Инженерный подход к моделированию',
    text: 'Учитываем конструктивную логику здания, а не только геометрию объекта.',
  },
  {
    title: 'Понимаем требования проектных команд',
    text: 'Модели и документация создаются с учётом требований архитекторов и инженеров.',
  },
  {
    title: 'Контроль уровня детализации (LOD)',
    text: 'Уровень проработки согласуется заранее и соблюдается на всех этапах.',
  },
  {
    title: 'Предсказуемые сроки и объём работ',
    text: 'Объём и сроки согласуются заранее и соблюдаются в процессе работы.',
  },
  {
    title: 'Конфиденциальность данных',
    text: 'Проектная информация используется только в рамках выполнения работ.',
  },
];

const Trust = () => {
  return (
    <section className="section trust">
      <div className="container">
        <div className="trust__wrapper">
          <HomeSectionAccordion
            id="trust"
            title="Почему нам доверяют проекты"
            collapsedSummary="Принципы точной, предсказуемой и конфиденциальной работы."
          >
            <div className="trust__grid">
            {trustItems.map(({ title, text }, index) => (
              <article key={title} className="trust__card">
                <div className="trust__badge">{String(index + 1).padStart(2, '0')}</div>
                <h2 className="trust__card-title">{title}</h2>
                <p className="trust__card-text">{text}</p>
              </article>
            ))}
            </div>
          </HomeSectionAccordion>
        </div>
      </div>
    </section>
  );
};

export default Trust;
